export function DashboardTiremetrixCtrl ($state, $scope, $translate, messages, workshopAPI) {

  $scope.tableSettings = {
    columns: [
      {
        field : 'tyre_identification_number',
        header: {
          text: $translate.instant('TIREMETRIX_SPACE.TIN_DOT')
        }
      },
      {
        field : 'invoice_number',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.INV_NO')
        }
      },
      {
        field : 'mspn',
        header: {
          text: $translate.instant('TIREMETRIX_SPACE.MSPN_ITEM_CODE')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_TYRES_REGISTRATIONS_OUTSTANDING')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10 ],
      queryCount: () => workshopAPI.get('/vehicle_tyre_registrations/outstanding_registrations_count').then(data => data.count)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.onRowDoubleClick = function (event) {
    $state.go('app.invoice', {
      customer_id: event.row.job_customer_id || event.row.customer_id,
      vehicle_id : event.row.job_vehicle_id || event.row.vehicle_id,
      id         : event.row.job_id || event.row.invoice_id
    });
  };

  $scope.getTyres = ( params ) => {
    return workshopAPI.get('/vehicle_tyre_registrations/outstanding_registrations', [
      params.pageSize,
      params.offset,
    ]).then(tyres => {
      $scope.tyres = tyres;

      return tyres;
    });
  };

  $scope.refresh = function () {
    $state.reload();

    messages.show($translate.instant('JS_SPACE.MESSAGES.REFRESHED'), 'success');
  };
}